module.exports = __webpack_public_path__ + "static/img/web_trading_service_icon.9f32ff82.png";